export default __webpack_public_path__ + "static/media/Error-art.5a300b55.png";